"use strict";

var _extends = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = arguments[t];

    for (var n in o) {
      Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
    }
  }

  return e;
},
    _createClass = function () {
  function n(e, t) {
    for (var o = 0; o < t.length; o++) {
      var n = t[o];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, o) {
    return t && n(e.prototype, t), o && n(e, o), e;
  };
}();

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    ReactLink = require("react-router-dom").Link,
    DropdownItem = function () {
  function o(e) {
    _classCallCheck(this, o);

    var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));

    return t.onSelect = t.onClick.bind(t), t.onKeyDown = t.onKeyDown.bind(t), t.onKeyUp = t.onKeyUp.bind(t), t;
  }

  return _inherits(o, React.Component), _createClass(o, [{
    key: "onClick",
    value: function value(e) {
      e.stopPropagation(), this.props.onSelect(e, this.props.option);
    }
  }, {
    key: "onKeyDown",
    value: function value(e) {
      this.props.onKeyDown(e, this.props.option);
    }
  }, {
    key: "onKeyUp",
    value: function value(e) {
      this.props.onKeyUp(e, this.props.option);
    }
  }, {
    key: "getLinkItem",
    value: function value() {
      return this.props.option.useReactLink ? React.createElement(ReactLink, {
        to: this.props.option.href,
        disabled: this.props.option.disabled,
        onKeyDown: this.onKeyDown,
        onKeyUp: this.onKeyUp,
        onClick: this.onSelect
      }, this.props.option.text || this.props.option.element) : React.createElement("a", {
        href: this.props.option.href,
        target: this.props.option.newTab ? "_blank" : null,
        disabled: this.props.option.disabled,
        title: this.props.option.text,
        onKeyDown: this.onKeyDown,
        onKeyUp: this.onKeyUp,
        onClick: this.onSelect
      }, this.props.option.text || this.props.option.element);
    }
  }, {
    key: "getButtonItem",
    value: function value() {
      return React.createElement("button", {
        disabled: this.props.option.disabled,
        title: this.props.option.text,
        onKeyDown: this.onKeyDown,
        onKeyUp: this.onKeyUp,
        onClick: this.onSelect
      }, this.props.option.text || this.props.option.element);
    }
  }, {
    key: "render",
    value: function value() {
      var e = null;
      e = this.props.option.href ? this.getLinkItem() : this.getButtonItem();
      var t = classnames("blx-dropdown-item", this.props.className, {
        "blx-disabled": this.props.option.disabled,
        "blx-selected": this.props.selected
      });
      return React.createElement("li", {
        style: this.props.style,
        className: t,
        ref: this.props.forwardedRef
      }, e);
    }
  }]), o;
}();

DropdownItem.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  option: PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    href: PropTypes.string,
    element: PropTypes.node,
    key: PropTypes.string,
    useReactLink: PropTypes.bool
  }).isRequired,
  selected: PropTypes.bool,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onSelect: PropTypes.func
}, DropdownItem.defaultProps = {
  className: "",
  style: null,
  selected: !1,
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  onSelect: function onSelect() {}
}, module.exports = React.forwardRef(function (e, t) {
  return React.createElement(DropdownItem, _extends({}, e, {
    forwardedRef: t
  }));
});